import React from "react";
import Alert from "../../shared/Alert";
import OutlineButton from "../../shared/buttons/OutlineButton";
import PrimaryButton from "../../shared/buttons/PrimaryButton";
import Loading from "../../shared/Loading";
import { ApprovalCard } from "./PostApprovalPresentation";

const copyFor = (presentation) => {
  if (presentation === "finalizing") {
    return {
      headline: "Confirming your result",
      subcopy: "We're retrieving your final result.",
      status: "Confirming your result.",
    };
  }

  return {
    headline: "Bank account linked!",
    subcopy:
      "We're reviewing your account to determine your credit limit and product eligibility.",
    status: "Checking your eligibility...",
  };
};

const PostApprovalPlaidProcessingView = ({
  presentation,
  recoveryAction = "status",
  onRetryStatus,
  onRetryEntities,
  onRetryRoute,
  onReauthenticate,
  busy,
  headline,
  subcopy,
}) => {
  if (presentation === "idle") return null;

  if (presentation === "terminal") {
    return <Loading className="h-14 w-14" containerClass="my-14" />;
  }

  const copy = copyFor(presentation);
  const isStatusRecovery = presentation === "status_recovery";
  const isAuthRecovery = presentation === "auth_recovery";
  const statusMessage = isStatusRecovery
    ? "We couldn't confirm your result."
    : isAuthRecovery
    ? "Your session needs to be verified."
    : copy.status;

  return (
    <ApprovalCard role="main" aria-label="Bank connection review">
      <h1>{headline || copy.headline}</h1>
      <p>{subcopy || copy.subcopy}</p>
      {(isStatusRecovery || isAuthRecovery) && (
        <p role="status" aria-live="polite">
          {statusMessage}
        </p>
      )}
      {isStatusRecovery && (
        <>
          <Alert
            icon={["far", "triangle-exclamation"]}
            alertText="We couldn't confirm your result"
            alertSubtext="Check your connection and try again."
          />
          <OutlineButton
            buttonColor="border-primary text-primary"
            buttonText="Retry"
            disabled={busy}
            onClick={(event) => {
              event.preventDefault();
              const retry =
                recoveryAction === "route"
                  ? onRetryRoute
                  : recoveryAction === "entities"
                  ? onRetryEntities
                  : onRetryStatus;
              retry?.();
            }}
          />
        </>
      )}
      {isAuthRecovery && (
        <>
          <Alert
            icon={["far", "triangle-exclamation"]}
            alertText="Your session needs to be verified"
          />
          <PrimaryButton
            buttonColor="bg-primary"
            buttonText="Verify again"
            disabled={busy}
            onClick={(event) => {
              event.preventDefault();
              onReauthenticate?.();
            }}
          />
        </>
      )}
      {!isStatusRecovery && !isAuthRecovery && (
        <div className="post-approval-loader">
          <Loading className="h-20 w-20" containerClass="my-0" />
          <p role="status" aria-live="polite">
            {statusMessage}
          </p>
        </div>
      )}
    </ApprovalCard>
  );
};

export default PostApprovalPlaidProcessingView;
